import axios from 'axios';
import { API } from '../utils/constants';

/**
 * Shared CV formatting helpers (URPE format). Used by every create-document
 * screen that takes a CV so the "attach → auto-format" experience is identical
 * everywhere. The format-cv endpoint goes through a task + poll, so there is no
 * proxy-timeout risk on long rewrites.
 */

/**
 * Format a CV into the URPE guideline format. Pass EITHER `file` OR `cvText`.
 * Returns the result object { formatted_cv, analysis }. Throws on failure.
 */
export async function requestCvFormat({ file, cvText, clientId }) {
  const token = localStorage.getItem('token');
  const fd = new FormData();
  if (file) fd.append('file', file);
  if (cvText) fd.append('cv_text', cvText);
  if (clientId) fd.append('client_id', clientId);

  const res = await axios.post(`${API}/whitepapers/format-cv`, fd, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
  });
  const taskId = res.data && res.data.task_id;
  if (!taskId) throw new Error('No se pudo iniciar el formateo del CV');

  return await new Promise((resolve, reject) => {
    const poll = setInterval(async () => {
      try {
        const st = await axios.get(`${API}/whitepapers/extraction-status/${taskId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const s = st.data && st.data.status;
        if (s === 'completed' && st.data.result) {
          clearInterval(poll);
          resolve(st.data.result);
        } else if (s === 'error' || s === 'failed') {
          clearInterval(poll);
          reject(new Error((st.data && st.data.error) || 'Error al formatear el CV'));
        }
      } catch (e) {
        // transient poll error — keep trying
      }
    }, 3000);
  });
}

/** Best-effort: save the formatted CV as the client's dossier CV (reused by every generator). */
export async function saveCvToDossier(clientId, cvText) {
  if (!clientId || !cvText) return;
  try {
    const token = localStorage.getItem('token');
    await axios.put(
      `${API}/clients/${clientId}/dossier`,
      { cv_text: cvText },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (e) {
    // best-effort — never blocks the flow
  }
}
